<template>
  <div class="shopDetail">
    <div class="com-top">
      <van-nav-bar
        title="商品详情"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>

    <div class="page_scroll1">
      <div class="main">
        <div class="pro-desc">
          <div class="wp2">
            <img :src="shop_info.img" alt="">

            <ul class="ul-list2 fix">
              <li>
                <img :src="shop_info.home_page1" alt="">
              </li>
              <li>
                <img :src="shop_info.home_page2" alt="">

              </li>
              <li>
                <img :src="shop_info.home_page3" alt="">
              </li>
            </ul>
            <ul class="ul-ylist3">
              <li>
                <div class="con"><a href="javascript:;"><img :src="shop_info.accessory1" alt=""></a></div>
              </li>
              <li>
                <div class="con"><a href="javascript:;"><img :src="shop_info.accessory2" alt=""></a></div>
              </li>
              <li>
                <div class="con"><a href="javascript:;"><img :src="shop_info.accessory3" alt=""></a></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="desc-wrap">
          <div>
            <img :src="shop_info.particulars" alt="">
          </div>

          <div class="con con7">
            <div class="wp2">
              <h5 class="g-tit2">公司简介</h5>
              <div class="info">
<!--                <h5>杭州恩氏基因技术发展有限公司</h5>-->
                <h5>杭州仟源恩氏基因技术有限公司</h5>
                <p>系上市公司山西仟源医药集团股份有限公司（仟源医药<b>300254</b>）旗下控股子公司，主要从事基因检测、个人基因组DNA保存等相关服务和产品开发，属国家重点支持的高新技术范围。2008年起至今一直被认定为国家高新技术企业。公司专注基因产业，致力于全球最大的实物型基因保存专业机构建设，并提供基因检测以及生物信息解读后续增值服务。
                </p>
              </div>
              <div class="logo-con">
                <div class="pic"><a href="javascript:;"><img src="../../assets/images/logo2.png" alt=""></a></div>
                <div class="txt">
                  <!-- <a href="javascript:;">了解恩氏基因</a> >> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <!-- 底部 -->
    <div class="h44"></div>
    <div class="fd1 fd2">
      <div class="wp2">
        <!--
         <span class="cart-input" :class="checked ? 'checked': ''" @click="selectGood()"></span>
                    <span href="javascript:;" :class="checked ? 'icon-collection-active' : 'icon-collection'"
                    style="float: left;display: inline-block;" @click.prevent="addCollection()"></span>
                    <span style="display: inline-block;margin-left：10px;vertical-align: middle;margin-top:8px;" @click.prevent="addCollection()">收藏</span>
                    -->
        <el-button round @click="centerDialogVisible = true" >点击二维码</el-button>

        <el-button type="primary" v-show="type == 2" round @click.prevent="payOrderPage">立即购买</el-button>

      </div>
    </div>

    <el-dialog
      :visible.sync="centerDialogVisible"
      width="80%"
      center>
      <el-image
        style="width: 100%; height: 6rem"
        :src="imgurl"></el-image>

    </el-dialog>

    <van-dialog class="van-dialog1"
                v-model="dialog.show"
                :showConfirmButton="dialog.showConfirmButton"
                :overlayStyle="dialog.overlayStyle">
      <div class="dn-top">
        <div class="dp-fl">选择新、老用户</div>
        <div class="dp-fr">
          <van-icon name="cross" size="0.5rem" @click.prevent="closeDialog"/>
        </div>
      </div>
      <div class="dn-bot">
        <van-radio-group v-model="dialog.radio">
          <van-radio name="1">新用户</van-radio>
          <van-radio name="2">老用户</van-radio>
        </van-radio-group>
      </div>
      <van-button type="info" size="large" @click="clickradio1">确定</van-button>
    </van-dialog>

    <van-dialog class="van-dialog1 van-dialog2"
                v-model="dialog.show2"
                :showConfirmButton="dialog.showConfirmButton"
                :overlayStyle="dialog.overlayStyle">
      <div class="dn-top">
        <div class="dp-fl">选择采集人</div>
        <div class="dp-fr">
          <van-icon name="cross" size="0.5rem" @click.prevent="closeDialog"/>
        </div>
      </div>
      <div class="dn-bot">
        <van-radio-group v-model="dialog.radio2">
          <van-radio :name="index" v-for="(item, index) in OldList" :key="index">
            <div class="dn-radio">
              <div class="dp1"><b>{{item.gather_name}}</b>{{item.phone}}</div>
              <div class="dp2">身份证号：{{item.card}}</div>
            </div>
          </van-radio>

        </van-radio-group>

      </div>
      <van-button type="info" size="large" @click="clickradio2">确定</van-button>
    </van-dialog>


  </div>
</template>
<script>
  import Vue from 'vue'
  import { NavBar, Dialog, RadioGroup, Radio, Button } from 'vant'

  Vue.use(NavBar)
  Vue.use(Dialog)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(Button)

  export default {
    name: 'shopDetail',
    data() {
      return {
        type: localStorage.getItem('type'), //用户角色类型
        centerDialogVisible: false,//二维码弹窗
        dialog: {
          show: false,
          show2: false,
          showConfirmButton: false,
          overlayStyle: {
            background: 'rgba(0,0,0,.5)'
          },
          radio: '1',
          radio2: '1',
        },
        salesman_id: '',
        checked: false,
        user_id: localStorage.getItem('user_id'),
        commodity_id: this.$route.params.commodity_id,
        items: [],
        options: {},
        swiperOption: {
          notNextTick: true,
          //循环
          loop: true,
          //设定初始化时slide的索引
          initialSlide: 0,
          //自动播放
          autoplay: false,
          // 设置轮播
          effect: 'slide',
          //滑动速度
          speed: 800,
          //滑动方向
          //滑动之后回调函数
          on: {
            slideChangeTransitionEnd: function () {
              // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            }
          },
          //分页器设置
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            // bulletActiveClass: 'my-bullet-active',
          }
        },
        swiperSlides: [
          {
            image: require('../../assets/images/yp16.jpg'),
            url: ''
          },
          {
            image: require('../../assets/images/yp16.jpg'),
            url: ''
          },
          {
            image: require('../../assets/images/yp16.jpg'),
            url: ''
          },
          {
            image: require('../../assets/images/yp16.jpg'),
            url: ''
          }
        ],
        shop_info: {},
        OldList: [],
        imgurl: '',
        arr: []
      }
    },
    mounted() {
      // this.$loading.show()
      this.onClickRight()

    },
    created() {
      console.log('user_id:', this.user_id)
      this.salesman_id = this.$utils.getUrlKey('salesman_id')
      this.getshopDetail()
      this.onClickRight()
      // this.getOldList()
      this.getCode()



    },
    methods: {
      onClickRight() {
        let that = this

        that.$share.WxInit('恩氏基因', '恩氏基因', '', that.user_id, that.commodity_id)
      },
      // 获取弹窗内的老用户列表
      getOldList() {
        this.$http.api.getOldList({
          user_id: this.user_id
        }).then(res => {

          this.OldList = res

        })
      },
      // 生成二维码
      getCode() {

        console.log('commodity_id:', this.commodity_id) //8a81838d76f0a40e0176f0a9ffb00006


         this.imgurl = this.commonurl+ '/commodity/code?commodity_id=' + this.commodity_id


      },
      // 返回
      onClickLeft() {
        this.$router.go(-1)
      },
      getshopDetail() {
        this.$http.api.shopDetail({
          // user_id: this.user_id,
          commodity_id: this.commodity_id
        }).then(result => {
          // this.$loading.hide()
          this.shop_info = { ...result }
          if (this.shop_info.style == 1) {
            this.checked = true
          } else {
            this.checked = false
          }
        })
      },
      payOrderPage() {
        // this.dialog.show = true
        // this.dialog.show2 = true
        if (localStorage.getItem('type') == 1) {
          this.$router.push({
            name: 'payGoods',
            params: { 'commodity_id': this.commodity_id, 'salesman_id': this.salesman_id }
          })
        } else if (localStorage.getItem('type') == 2) {
          console.log(this.commodity_id)

          this.arr.push(this.commodity_id)
          console.log(this.arr)
          localStorage.setItem('commodityIdList', JSON.stringify(this.arr))

          this.$router.push({
            name: 'paygoodsywy',
            // params: {'commodity_id': this.commodity_id, 'salesman_id': this.salesman_id}
          })

        } else {
          /*
          this.$router.push({
            name: 'login'
          })
          */

          window.location.href = this.$store.state.windowhref
        }

      },
      // 关闭弹窗
      closeDialog() {
        this.dialog.show = false
        this.dialog.show2 = false

      },

      clickradio1() {
        console.log(this.dialog.radio)
        if (this.dialog.radio == 1) {//新用户
          this.dialog.show = false

          if (localStorage.getItem('type') == 1) {
            this.$router.push({
              name: 'payGoods',
              params: { 'commodity_id': this.commodity_id, 'salesman_id': this.salesman_id }
            })
          } else if (localStorage.getItem('type') == 2) {
            // localStorage.setItem('commodityIdList',JSON.stringify(this.checkedCities));
            console.log(this.commodity_id)
            /*
                              this.$router.push({
                                 name: 'paygoods1',
                                 params: {'commodity_id': this.commodity_id, 'salesman_id': this.salesman_id}
                              })

             */
          } else {
            /*
            this.$router.push({
              name: 'login'
            })

             */

            window.location.href = this.$store.state.windowhref
          }

        } else {//老用户
          this.dialog.show = false
          this.dialog.show2 = true

        }
      },
      clickradio2() {
        console.log(this.dialog.radio2)
        let sr = this.OldList[this.dialog.radio2]
        console.log(sr)
      },
      addCollection() {
        let _this = this
        if (this.checked) {
          // 删除收藏品
          _this.$http.api.delCollection({
            user_id: this.user_id,
            commodity_id: this.commodity_id
          }).then(result => {
            this.checked = false
            const toast = this.$createToast({
              txt: '已取消收藏',
              type: 'txt'
            }).show()
          })
        } else {
          this.$http.api.addCollection({
            user_id: this.user_id,
            commodity_id: this.commodity_id
          }).then(result => {
            this.checked = true
            const toast = this.$createToast({
              txt: '收藏成功',
              type: 'txt'
            }).show()
          })
        }
      }
    }
  }
</script>
<style lang="less">
  .van-nav-bar .van-icon {
    color: #4B4B4C;
  }

  .van-nav-bar__text {
    color: #E85C00;
  }

  .el-dialog__header {
    padding: 0.2rem 0.5rem;

    .el-dialog__headerbtn {
      top: 0.2rem;
    }
  }
</style>
<style lang="less" scoped>

  .van-dialog1 {
    .dn-top {
      padding: 0.4rem 0.5rem;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #000;
      font-size: 0.5rem;
    }

    .dn-bot {
      padding: 0.8rem 1rem;

      .van-radio-group {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .van-radio {

        }
      }

    }

    &.van-dialog2 {
      .dn-bot {
        padding: 0.3rem 0.5rem;

        .van-radio-group {
          display: block;

          .van-radio {
            padding: 0.4rem 0;

            &:not(:last-of-type) {
              border-bottom: 1px solid #ddd;
            }

            .dn-radio {
              font-size: 0.4rem;
              color: #666666;

              .dp1 {
                margin: 0 0 0.2rem;

                b {
                  font-size: 0.45rem;
                  color: #333333;
                  margin: 0 0.3rem 0 0;
                }
              }
            }
          }
        }

      }
    }
  }

  .fd1 {
    .wp2 {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 0.5rem;

      .el-button {
        padding: 0.2rem 0.5rem;
        margin: 0 0.6rem;
      }

      a {
        margin: 0;
      }
    }
  }

  .page_scroll1 {
    padding: 1.35rem 0 0;
  }

  .shopDetail {
    img {
      width: 100%;
    }
  }

  .con3 {
    .ul-ylist6 {
      a {
        img {
          position: absolute;
          top: 0;
        }
      }
    }
  }

  .pro-desc {
    padding: 0;

    .pic {
      img {
        width: 161px;
      }
    }
  }

  .ul-ylist3 {
    a {
      width: 100%;
      height: 100%;
      display: inline-block;

      img {
        display: inline-block;
        vertical-align: middle;
        max-height: 100px;
        width: auto;
      }
    }
  }

  #pagnationShop {
    position: static;
  }

  .slider-pic .swiper-container {
    padding-bottom: 26px;
  }

  // #pagnation /deep/ .swiper-pagination-bullet {
  //       width:5px;
  //       height:5px;
  //       margin-right: 5px;
  // }
  .slider-pic .swiper-pagination-bullet {
    margin-right: 5px;
  }

  .ul-list2.fix {
    img {
      width: 100%;
    }
  }

  .ul-ylist3 .con {
    height: auto;
  }

  .icon-collection {
    width: 18px;
    height: 18px;
    background: url('../../assets/images/coll1.png') no-repeat center center;
    background-size: 100% 100%;
    margin-top: 5px;
  }

  .icon-collection-active {
    width: 18px;
    height: 18px;
    background: url('../../assets/images/coll2.png') no-repeat center center;
    background-size: 100% 100%;
    margin-top: 5px;
  }

</style>


